var map = {
	"./home/McIndex": [
		8063,
		696,
		63
	],
	"./home/McIndex.vue": [
		8063,
		696,
		63
	],
	"./home/PadIndex": [
		87297,
		696,
		979,
		125
	],
	"./home/PadIndex.vue": [
		87297,
		696,
		979,
		125
	],
	"./home/PcIndex": [
		63359,
		696,
		979,
		999
	],
	"./home/PcIndex.vue": [
		63359,
		696,
		979,
		999
	],
	"./login/Mclogin": [
		15813,
		813
	],
	"./login/Mclogin.vue": [
		15813,
		813
	],
	"./login/Padlogin": [
		68801,
		801
	],
	"./login/Padlogin.vue": [
		68801,
		801
	],
	"./login/login": [
		9594,
		594
	],
	"./login/login.vue": [
		9594,
		594
	],
	"./video/VideoIndex": [
		40120,
		120,
		867
	],
	"./video/VideoIndex.vue": [
		40120,
		120,
		867
	],
	"./video/haikang": [
		91441,
		441
	],
	"./video/haikang.vue": [
		91441,
		441
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99555;
module.exports = webpackAsyncContext;